import React from 'react'
import { renderToString } from 'react-dom/server'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BorderPicker } from 'components/MarkupDetails/ColorPicker'
import Panel from 'components/Panel'
import ConfigurationDetails from './ConfigurationDetails'
import DeviceDescription from 'components/DeviceDescription'
import ConfigurationSummary from 'components/DoorEntityConfigurationSummary'
import { updateUiAction } from 'actions/uiActions'
import { updateEntityAction, deleteDoorAction } from 'actions/entityActions'
import { updateCurrentEntityAction } from 'actions/applicationActions'
import { messageAction } from 'actions/messageActions'

const mapStateToProps = state => {
  const { entities: { doors: { byId } }, currentEntity: { id }, map: { ref }, ui: { doorDetailsPanelOpen, cameraDescriptionPanelOpen } } = state

  return {
    currentDoor: byId[id],
    map: ref,
    doorDetailsPanelOpen,
    cameraDescriptionPanelOpen
  }
}

class DoorDetails extends React.Component {
  render() {
    const { currentDoor, map, doorDetailsPanelOpen, cameraDescriptionPanelOpen, updateUiAction, messageAction,
      updateEntityAction, deleteDoorAction, updateCurrentEntityAction, classes } = this.props
    const { id, locked, name, location, color, controllerId } = currentDoor

    return (
      <div className={classes.details}>
        <div className={classes.topUiControls}>
          <a onClick={_ => updateCurrentEntityAction({ id: controllerId, type: 'doorController' })}>
            <FontAwesomeIcon icon='caret-left' className={classes.goBackButton} />
            Door Controller
          </a>
          <a
            onClick={_ => {
              if (locked) {
                messageAction('generalError', 'Cannot delete locked Door. Right click to unlock.')
              } else if (window.confirm(`Are you sure you want to delete ${name}?`)) {
                deleteDoorAction(id)
              }
            }}
            className={classes.destroyButton}>
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </a>
        </div>
        <div className={classes.container}>
          <div title='Name' className={classes.label}>Name</div>
          <input
            type='text'
            onChange={({ target: { value } }) => updateEntityAction('doors', id, { name: value })}
            value={name || ''}
          />
          <div className={classes.actions}>
            <a onClick={_ => map.panTo(location)}>
              <FontAwesomeIcon icon='map-marker-alt' />
            </a>
            <a onClick={_ => updateEntityAction('doors', id, { locked: !locked })}>
              <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} />
            </a>
          </div>
        </div>
        <div className={classes.container}>
          <span className={classes.colorLabel}>Color</span>
          <BorderPicker
            currentMarkup={{ id, type: 'doorController', strokeColor: color }}
            updateMarkupAction={(id, action) => updateEntityAction('doors', id, { color: action.strokeColor })}
            cameraOnly
          />
        </div>
        <div className={classes.container}>
          <span className={classes.colorLabel} style={{ width: '11rem' }}>Configuration</span>
          <div
            onClick={_ => updateUiAction({ modal: 'DoorControllerDesigner' })}
            className={classes.configureButton}
          >
            Configure Doors
          </div>
        </div>
        <div className={classes.summaryWrapper}>
          Summary
          <ConfigurationSummary style={{ paddingLeft: '.5rem' }} />
        </div>
        <Panel
          active={doorDetailsPanelOpen}
          component={<ConfigurationDetails />}
          title='Device Details'
          updateUiAction={updateUiAction}
          uiKey='doorDetailsPanelOpen'
        />
        <Panel
          active={cameraDescriptionPanelOpen}
          component={<DeviceDescription currentDevice={currentDoor} type='door' />}
          title='Location, Description, Notes'
          updateUiAction={updateUiAction}
          uiKey='cameraDescriptionPanelOpen'
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateUiAction, updateEntityAction, deleteDoorAction,
  updateCurrentEntityAction, messageAction })(injectSheet(style)(DoorDetails))



// WEBPACK FOOTER //
// ./src/components/DoorDetails/index.js